/**
 * Cart Shipping Location Detection
 * Handles adding location-specific classes to the body.
 * Supports: 'au', 'us' specific classes, and 'int' fallback.
 */

(function () {
  /**
   * Fetches browsing context suggestions (location data) from Shopify
   */
  const getShopifyLocation = async () => {
    try {
      const response = await fetch('/browsing_context_suggestions.json');
      return await response.json();
    } catch (error) {
      console.warn('Location detection failed:', error);
      return null;
    }
  };

  // Main execution
  getShopifyLocation().then(location => {
    const countryCode = location?.detected_values?.country?.handle?.toLowerCase();
    const body = document.body;
console.log('Country: ', countryCode)
    if (countryCode) {
      // Check for supported countries (AU and US)
      if (countryCode === 'au' || countryCode === 'us') {
        // Remove 'is-location-int' if it was added by other scripts
        // (This is important because sections.cart-drawer.js might run first and add it)
        body.classList.remove('is-location-int');

        // Add specific country class (e.g. is-location-us)
        body.classList.add(`is-location-${countryCode}`);
      } else {
        // Fallback for all other countries -> International
        body.classList.add('is-location-int');
      }
    } else {
      // Fallback if detection failed
      body.classList.add('is-location-int');
    }
  });
})();
